import {
  IGetCachedBillboardOrganizationContentProps,
  IOrganizationBillboardContent,
  ISaveBillboardOrganizationContentInCacheProps,
} from "pages/[tenant]/browse/types";
import {
  getCachedBillboardOrganizationContentFromSessionStorage,
  saveCachedBillboardOrganizationContentInSessionStorage,
} from "pages/[tenant]/browse/utils/cachedBillboardOrganizationContentUtils";

import { captureException, captureMessage } from "@sentry/nextjs";

export const useBillboardOrganizationService = () => {
  const getCachedBillboardOrganizationContent =
    async ({}: IGetCachedBillboardOrganizationContentProps): Promise<IOrganizationBillboardContent | null> => {
      try {
        const result =
          getCachedBillboardOrganizationContentFromSessionStorage();

        return result;
      } catch (error) {
        console.log("Erro (getCachedBillboardOrganizationContent): ", error);
        captureMessage("Erro (getCachedBillboardOrganizationContent)");
        captureException(error);

        return null;
      }
    };

  const saveBillboardOrganizationContentInCache = async ({
    payload,
  }: ISaveBillboardOrganizationContentInCacheProps): Promise<boolean> => {
    try {
      saveCachedBillboardOrganizationContentInSessionStorage(payload);

      return true;
    } catch (error) {
      console.log("Erro (saveBillboardOrganizationContentInCache): ", error);
      captureMessage("Erro (saveBillboardOrganizationContentInCache)");
      captureException(error);

      return false;
    }
  };

  return {
    getCachedBillboardOrganizationContent,

    saveBillboardOrganizationContentInCache,
  };
};
